import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.321 8.988c-.286 0-.56-.105-.762-.293L6.006 5.41 2.454 8.695q-.151.145-.35.224a1.15 1.15 0 0 1-1.188-.211A1 1 0 0 1 .68 8.38a.93.93 0 0 1 .007-.772 1 1 0 0 1 .242-.324l4.315-3.992C5.446 3.105 5.72 3 6.006 3s.56.105.763.292l4.315 3.992c.15.14.253.318.295.511a.93.93 0 0 1-.061.577c-.082.182-.22.338-.398.447-.177.11-.386.169-.599.169"
    }, null, -1)
  ]))]))
}
export default { render: render }